"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GlobalStyle;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _polished = require("polished");
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const background = `${_constants.bucketImageUrl}/background.webp`;
function GlobalStyle({
  cleanBackground,
  globalStyle
}) {
  const CreateGlobalStyle = (0, _styledComponents.createGlobalStyle)`
    ${({
    theme
  }) => (0, _styledComponents.css)`
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

        &::before,
        &::after {
          box-sizing: inherit;
        }
      }

      *,
      button,
      input {
        border: 0;
        outline: 0;
        font-family: ${theme.fonts.family.robotoFlex};
      }

      html,
      body {
        background: url(${background}) repeat center center;
        color: ${theme.colors.primaryDark};
        font-family: ${theme.fonts.family.robotoFlex};
        font-size: 62.5%;
        line-height: 1.5;

        *::-webkit-scrollbar {
          width: 1rem;
        }

        *::-webkit-scrollbar-track:hover {
          background-color: ${(0, _polished.opacify)(0.15, theme.colors.blackOpacity)};
          border-radius: 0.7rem;
        }
        
        *::-webkit-scrollbar-thumb {
          background-color: ${theme.colors.secondary};
          border-radius: 0.7rem;
          min-height: 3.5rem;

          &:hover {
            background-color: ${(0, _polished.lighten)(0.015, theme.colors.buttonBackground)};
          }

          &:active {
            background-color: ${(0, _polished.darken)(0.025, theme.colors.buttonBackground)};
          }
        }

        &::-webkit-scrollbar-track {
          background-color: ${theme.colors.primary};

          &:hover {
            background-color: ${(0, _polished.lighten)(0.05, theme.colors.primary)};
            border-radius: 0rem;
          }
        }

        *::selection {
          background-color: ${(0, _polished.opacify)(0.7, theme.colors.secondaryOpacity)};
          color: ${theme.colors.white};
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          line-height: 1.2;
        }

        ul {
          list-style-type: none;
        }

        a {
          text-decoration: none;
          color: inherit;
          &:hover {
            color: inherit;
          }
        }

        ${cleanBackground && (0, _styledComponents.css)`
          background: ${theme.colors.white};

          &::-webkit-scrollbar-track {
            background-color: ${theme.colors.white};

            &:hover {
              background-color: ${(0, _polished.opacify)(0.15, theme.colors.blackOpacity)};
            }
          }
        `}
      }

      ${globalStyle && globalStyle(theme)}
    `}
  `;
  return /*#__PURE__*/_react.default.createElement(CreateGlobalStyle, null);
}
;